package com.islamicmedia.shared.platform

import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob

actual class BackgroundAnalysisManager actual constructor() {

    actual val backgroundScope: CoroutineScope = CoroutineScope(SupervisorJob() + Dispatchers.Default)

    actual fun startLiveActivity(title: String) {
        // No-op on web
    }

    actual fun endLiveActivity(success: Boolean) {
        // No-op on web
    }

    actual fun startBackgroundExecution(title: String) {
        // No-op on web
    }

    actual fun stopBackgroundExecution() {
        // No-op on web
    }

    actual fun showCompletionNotification(title: String, success: Boolean, errorMessage: String?) {
        // No-op on web
    }

    actual fun requestNotificationPermission(onResult: (Boolean) -> Unit) {
        onResult(true)
    }

    actual val isNotificationPermissionGranted: Boolean
        get() = true

    @Suppress("UNUSED_PARAMETER")
    actual fun updateProgress(title: String, stepNumber: Int, totalSteps: Int, stepDescription: String) {
        // No-op on web
    }

    actual fun dismissNotifications() {
        // No-op on web
    }
}
